<template>
<div>
    Welcome to MySwitchPro,<br>
    We’ll now get to work finding the most competitively priced supplier and will notify you as soon as we have the details.
</div>
</template>

<script>
export default {
name: "NoBetterDeal"
}
</script>

<style scoped>

</style>
